<!-- @veltra/icons generated sha256:f7aea11d19578752 gen:8 source:src/svg/normal/star.svg -->
<script setup lang="ts">
defineOptions({ name: 'Star' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m9.425 6.144-.968-1.962a.51.51 0 0 0-.91 0l-.969 1.962a.5.5 0 0 1-.378.274l-2.165.315a.51.51 0 0 0-.281.865L5.32 9.126a.5.5 0 0 1 .144.444l-.37 2.156a.51.51 0 0 0 .736.535l1.937-1.018a.5.5 0 0 1 .467 0l1.937 1.018a.51.51 0 0 0 .736-.535l-.37-2.156a.5.5 0 0 1 .144-.444l1.567-1.528a.51.51 0 0 0-.281-.865l-2.165-.315a.5.5 0 0 1-.378-.274m5.108-.049a.3.3 0 0 1 .166.512l-2.94 2.866a.51.51 0 0 0-.146.448l.694 4.047a.3.3 0 0 1-.435.317l-3.635-1.911a.51.51 0 0 0-.47 0c-.84.44-3.636 1.91-3.636 1.91a.3.3 0 0 1-.435-.316l.694-4.047a.51.51 0 0 0-.145-.448l-2.94-2.866a.3.3 0 0 1 .166-.512l4.064-.59a.51.51 0 0 0 .38-.277l1.818-3.683a.3.3 0 0 1 .538 0l1.818 3.683a.51.51 0 0 0 .38.276z"
    />
  </svg>
</template>
